import React, { useState, useEffect } from "react";
import { FaUsers, FaClipboardList, FaCheckCircle } from "react-icons/fa";
import 'bootstrap/dist/css/bootstrap.min.css';

const Projects = () => {
  // Utilisez useState pour gérer les états des nombres
  const [peopleHelped, setPeopleHelped] = useState(2000);
  const [requests, setRequests] = useState(2000);
  const [projectsCompleted, setProjectsCompleted] = useState(1956);

  // Utilisez useEffect pour simuler l'augmentation des nombres
  useEffect(() => {
    const interval = setInterval(() => {
      // Incrémentez les nombres à chaque intervalle
      setPeopleHelped((prevPeopleHelped) => prevPeopleHelped + 1);
      setRequests((prevRequests) => prevRequests + 1);
      setProjectsCompleted((prevProjectsCompleted) => prevProjectsCompleted + 1);
    }, 1000); // Changez cet intervalle en fonction de vos besoins

    // Nettoyez l'intervalle lors du démontage du composant
    return () => clearInterval(interval);
  }, []);

  return (
    <footer className="text-center text-lg-start mt-5">
      <div className="container">
        <div className="row justify-content-center align-items-center">

        <div className="col-sm-6 col-md-4 col-lg-3 mb-3">
            <div className="card shadow p-3 bg-body rounded text-dark">
              <FaClipboardList size={40} style={{ marginBottom: "10px" }} />
              <p className="fs-3 mb-0">{requests}</p>
              <p className="fs-6">Demandes acceptées</p>
            </div>
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3 mb-3">
            <div className="card shadow p-3 bg-body rounded text-dark">
              <FaUsers size={40} style={{ marginBottom: "10px" }} />
              <p className="fs-3 mb-0">{peopleHelped}</p>
              <p className="fs-6">Personnes aidées</p>
            </div>
          </div>
          
          <div className="col-sm-6 col-md-4 col-lg-3 mb-3">
            <div className="card shadow p-3 bg-body rounded text-dark">
              <FaCheckCircle size={40} style={{ marginBottom: "10px" }} />
              <p className="fs-3 mb-0">{projectsCompleted}</p>
              <p className="fs-6">Projets accomplis</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Projects;
